import { Box, Center, Flex, Grid, Text } from '@chakra-ui/react'
import Spinner from './loading'
import LinkBadge from './linkBadge'
import { useKleomedesValidators } from '../hooks/useKleomedesValidators'
import { chains } from 'chain-registry'

export default function KleomedesValidatorChainsContainer() {
  const { isLoading, error, data } = useKleomedesValidators()

  const Chains = () => {
    if (isLoading || !data) return
    const kleomedesChains = data.validators
      .filter(validator => validator.status === 'BOND_STATUS_BONDED')
      .map(validator => validator.chain_name)

    if (!kleomedesChains) return <Text>There are no chains available</Text>

    const selectedChains = chains.filter(chain => kleomedesChains.includes(chain.chain_name))

    const chainComponents = selectedChains.map(chain => {
      const name = chain.pretty_name ?? ''
      const chainName = chain.chain_name
      const feeToken = chain.fees?.fee_tokens[0].denom
      const iconLink = chain.images ? chain.images[0]?.png : undefined
      return (
        <LinkBadge
          key={chainName}
          href={`\\delegate\\${chainName}`}
          text={name}
          iconLink={iconLink}
        />
      )
    })
    return (
      <Grid templateColumns={{ base: '1fr', lg: 'repeat(3, 1fr)' }} gap={12}>
        {chainComponents}
      </Grid>
    )
  }

  return (
    <Box maxW={{ xl: 'container.xl', base: '$100vh' }} mx="auto" p={{ xl: 20, base: 4 }}>
      {isLoading ? (
        <Flex position={'fixed'} top={0} left={0} right={0} bottom={0} zIndex={1000}>
          <Spinner />
        </Flex>
      ) : (
        <Box flexDir={{ lg: 'row', base: 'column' }}>
          <Box>
            <Center>
              <Box pb={2}>
                <Text
                  as={'span'}
                  fontSize={{ sm: 'xl', lg: '6xl' }}
                  fontWeight={700}
                  p={4}
                  style={{ whiteSpace: 'nowrap' }}
                >
                  Kleomedes validator chains
                </Text>
              </Box>
            </Center>
            <Box mt={8}>
              <Chains />
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  )
}
